import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import arrowRight from "../icons/arrow-right.svg";
import thermometer from "../icons/medium-thermometer.svg";
import appliances from "../icons/air-conditioner.svg";
import windows from "../icons/window.svg";
import car from "../icons/electric-car.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import SubText from "./SubText";
import SimpleText from "./SimpleText";

const Factors = ({ content }) => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: { xs: "10%", sm: "10%", md: "0%", lg: "5%" },
        marginTop: { xs: "0%", sm: "0%", md: "0%", lg: "6%" },
        padding: "10% 0",
      }}
    >
      <SubText text={content?.details?.title} />

      <SimpleText
        style={{
          fontSize: { xs: "4.5vw", sm: "4.5vw", md: "3.5vw", lg: "20px" },
          marginTop: "3%",
          color: "#2f2f2f",
          padding: { xs: "0 5%", lg: "0 52px" },
          textAlign: "center",
        }}
        text={content?.details?.subtitle}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
          width: "100%",
          marginTop: "2%",
          justifyContent: "space-evenly",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            width: { xs: "90%", md: "30%" },
            height: "100%",
            padding: "5% 0",
            margin: {
              xs: "5% 0 5% 0",
              sm: "5% 0 5% 0",
              md: "0",
            },
          }}
        >
          <Box width={{ xs: "45px", sm: "45px", md: "50px", lg: "100px" }}>
            <img style={{ width: "100%" }} src={content?.icons?.url1} />
          </Box>
          <Typography
            sx={{
              fontSize: { xs: "19px", md: "4vw", lg: "30px" },
              fontWeight: "400",
              color: theme.palette.secondary.main,
            }}
            variant="body2"
          >
            {content?.icons?.name1}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            width: { xs: "90%", md: "30%" },
            height: "100%",
            padding: "5% 0",
            margin: {
              xs: "5% 0 5% 0",
              sm: "5% 0 5% 0",
              md: "0",
            },
          }}
        >
          <Box width={{ xs: "45px", sm: "45px", md: "50px", lg: "100px" }}>
            <img style={{ width: "100%" }} src={content?.icons?.url2} />
          </Box>
          <Typography
            sx={{
              fontSize: { xs: "19px", md: "4vw", lg: "30px" },
              fontWeight: "400",
              color: theme.palette.secondary.main,
            }}
            variant="body2"
          >
            {content?.icons?.name2}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            width: { xs: "90%", md: "30%" },
            height: "100%",
            padding: "5% 0",
            margin: {
              xs: "5% 0 5% 0",
              sm: "5% 0 5% 0",
              md: "0",
            },
          }}
        >
          <Box width={{ xs: "45px", sm: "45px", md: "50px", lg: "100px" }}>
            <img style={{ width: "100%" }} src={content?.icons?.url3} />
          </Box>
          <Typography
            sx={{
              fontSize: { xs: "19px", md: "4vw", lg: "30px" },
              fontWeight: "400",
              color: theme.palette.secondary.main,
              whiteSpace: "nowrap",
            }}
            variant="body2"
          >
            {content?.icons?.name3}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Factors;
